<template>
  <BaseCard
    :heading="$t('admin.treatwell.pages.dashboard.last_minute.heading')"
    :description="$t('admin.treatwell.pages.dashboard.last_minute.description')"
    :toggle="!!enabled"
    @update:toggle="onToggle"
    v-test="'tw-last-minute-discount'"
    v-intercom="'mp-dashboard-task-last-minute-discount'"
  >
    <BaseText
      :routerLink="{ name: 'treatwell-salon-last-minute-discount' }"
      iconBefore="edit"
      v-test="'tw-last-minute-discount-edit'"
    >
      {{ $t('admin.treatwell.pages.dashboard.last_minute.edit') }}
    </BaseText>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCompanyStore } from '@/stores/company';

// Salons switch last-minute discounts on and off more often than the rest, so they sit on the
// dashboard. The toggle opens the existing modals, which do the saving.
const router = useRouter();
const { companySettings } = storeToRefs(useCompanyStore());

const enabled = computed(
  () => companySettings.value.bookings.lastMinuteDiscountEnabled,
);

const onToggle = (value: boolean) => {
  router.push({
    name: value
      ? 'treatwell-salon-last-minute-discount'
      : 'treatwell-salon-disable-last-minute-discount',
  });
};
</script>
